
/**
 * 系统级状态数据
 */

import {cookieDao} from "@/utils/Hibernate";

export default {
  namespaced: true,

  state: {
    /** 侧边按钮折叠与否 */
    menuCollapsed: !!cookieDao.getString("collapsed"),

    /** 主题色 */
    theme: "1890ff",
  },

  mutations: {
    /**
     * 暂时没用上
     */
    SET_MENUCOLLAPSED: (state, data) => state.menuCollapsed = data

  },

  actions: {

    /**
     * 循环切换按钮折叠
     **/
    toggleMenuCollapsed: (context) => context.dispatch("setMenuCollapsed", !context.state.menuCollapsed),

    /**
     * 设置按钮折叠状态
     * @param context
     * @param bool  { Boolean } 是否折叠
     **/
    setMenuCollapsed: (context, bool) => {
      context.state.menuCollapsed = bool
      cookieDao.setString("collapsed", bool ? "true": '');
    },
  }
}
